import { ICompanyProps } from '@/entities/Company'
import { EmptyResponsePropsFactory, IResponseProps } from '@/entities/Response'

export interface ICompanyState {
  response: IResponseProps<ICompanyProps>
  current: ICompanyProps | null
  filter: string
}

export const state = (): ICompanyState => ({
  response: EmptyResponsePropsFactory(),
  current: null,
  filter: 'all'
})

export default state
